import p5Types from 'p5';
import { Card as CardType } from '@src/lib/types';

import { getCardImageString } from '@src/lib/utils/card';

export default class Card {
  card: CardType;
  width: number;
  height: number;
  imageString: string;
  image: any;
  x_offset: number;
  y_offset: number;
  x_offset_mod: number;
  y_offset_mod: number;
  p5Ref: p5Types;

  static cardSizeMultiplier: number;

  constructor(
    card: CardType,
    width: number,
    height: number,
    cardSizeMultiplier: number,
    image: any,
    p5: p5Types,
  ) {
    this.card = card;

    this.width = width;
    this.height = height;

    this.imageString = getCardImageString(this.card);
    this.image = image;

    this.x_offset = 0;
    this.y_offset = 0;
    this.x_offset_mod = 0;
    this.y_offset_mod = 0;

    this.p5Ref = p5;

    Card.cardSizeMultiplier = cardSizeMultiplier;
  }

  getCardColor() {
    const color = this.card.color;
    if (color === 'black') return 'gray';
    return color;
  }

  draw(p5: p5Types, highlight?: boolean) {
    // render shadows
    p5.drawingContext.shadowOffsetX =
      -5 * (Card.cardSizeMultiplier + (1 - Card.cardSizeMultiplier));
    p5.drawingContext.shadowOffsetY =
      -5 * (Card.cardSizeMultiplier + (1 - Card.cardSizeMultiplier));
    p5.drawingContext.shadowBlur =
      25 * (Card.cardSizeMultiplier + (1 - Card.cardSizeMultiplier));
    p5.drawingContext.shadowColor = highlight ? this.getCardColor() : 'black';

    // rect thats same size as card
    p5.image(
      this.image,
      this.x_offset + this.x_offset_mod,
      this.y_offset + this.y_offset_mod,
      this.width,
      this.height,
    );

    // reset shadows
    p5.drawingContext.shadowOffsetX = 0;
    p5.drawingContext.shadowOffsetY = 0;
    p5.drawingContext.shadowBlur = 0;
    p5.drawingContext.shadowColor = 'transparent';
  }
}
